// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_2787e5dfdf--spinner--uXgOG","circle-spin":"_2787e5dfdf--circle-spin--HhIQz"};